function cpfValidation(cpf: string) {
  if (typeof cpf !== "string") return false;

  const cpfLimpo = cpf.replace(/\D/g, '');
  if (cpfLimpo.length !== 11 || /^(\d)\1{10}$/.test(cpfLimpo)) {
    return false;
  }
  const calcularDigito = (base: string, pesoInicial: number): number => {
    let soma = 0;
    for (let i = 0; i < base.length; i++) {
      soma += parseInt(base[i]) * (pesoInicial - i);
    }
    const resto = soma % 11;
    return resto < 2 ? 0 : 11 - resto;
  };
  const baseCPF = cpfLimpo.slice(0, 9);
  const digito1 = calcularDigito(baseCPF, 10);
  const digito2 = calcularDigito(baseCPF + digito1, 11);
  return cpfLimpo === baseCPF + digito1.toString() + digito2.toString();
}

export default cpfValidation;